export default string =>
  string.replace(/<(?:.|\n)*?>/gm, '').replace(/&nbsp;/, ' ')
